import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';

type TimeUnit = 'hours' | 'days';

export {
  APPOINTMENT_LEAD_TIME_MAX_HOURS,
  APPOINTMENT_LEAD_TIME_MAX_DAYS,
  CANCELLATION_POLICY_MAX_HOURS,
  CANCELLATION_POLICY_MAX_DAYS,
} from './constants';

const minutesToDays = (minutes: number) => dayjs.duration(minutes, 'minutes').asDays();

const minutesToHours = (minutes: number) => dayjs.duration(minutes, 'minutes').asHours();

const hoursToMinutes = (hours: number) => dayjs.duration(hours, 'hours').asMinutes();

const daysToMinutes = (days: number) => dayjs.duration(days, 'days').asMinutes();

export const convertMinutesToDaysAndHours = (minutes: number): { timeUnit: TimeUnit; duration: number } => {
  const days = minutesToDays(minutes);

  if (Number.isInteger(days) && days >= 1) {
    return { timeUnit: 'days', duration: days };
  }

  return { timeUnit: 'hours', duration: minutesToHours(minutes) };
};

export const convertDaysAndHoursToMinutes = (duration: number, timeUnit: TimeUnit): number | undefined => {
  if (!timeUnit) return;
  const minutes = timeUnit === 'days' ? daysToMinutes(duration) : hoursToMinutes(duration);
  return Math.round(minutes);
};

type MaximumDurationErrorProps = {
  value: number;
  timeUnit: TimeUnit;
  maxHours: number;
  maxDays: number;
};

export const getMaximumDurationError = ({ value, timeUnit, maxHours, maxDays }: MaximumDurationErrorProps) => {
  if (value === undefined || timeUnit === undefined) return '';

  if (timeUnit === 'days' && value > maxDays) {
    return i18next.t('{{count}} days is the maximum', { count: maxDays, ns: 'schedule-settings' });
  }
  if (timeUnit === 'hours' && value > maxHours) {
    return i18next.t('{{count}} hours is the maximum', { count: maxHours, ns: 'schedule-settings' });
  }

  return '';
};
